<template>
    <div class="document row mx-0" role="button" @click="viewDocument(document)">
        <div class="col-9 col-lg-10 d-flex gap-2">
            <i :class="['document-icon fi', getIconByExtension(document.extension)]"></i>
            <div class="details">
                <h6 class="mb-0 name scrollable">{{ document.name ?? getNameFromPath(document.path) }}</h6>
                <small>{{ formatDate(document.created_at) }}</small>
            </div>
        </div>
        <div class="col-3 col-lg-2 d-flex justify-content-end align-items-center">
            <basic-button
                icon="fi-rr-eye"
                cls="btn-view btn-secondary  btn-sm"/>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY HH:mm');
        },
        getNameFromPath(path) {
            return path.split('/').pop();
        },
        viewDocument(document) {
            window.open(document.absolute_path, '_blank');
        },
        getIconByExtension(extension) {
            if (extension === 'pdf') {
                return 'fi-rr-file-pdf';
            } else if (extension === 'doc' || extension === 'docx') {
                return 'fi-rr-file-word';
            } else if (extension === 'xls' || extension === 'xlsx') {
                return 'fi-rr-file-excel';
            } else if (extension === 'ppt' || extension === 'pptx') {
                return 'fi-rr-file-powerpoint';
            } else {
                return 'fi-rr-file';
            }
        }
    }
}
</script>

<style scoped>
.document {
    background: #ecf9f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 25px;
}

.document .details {
    max-width: 100%;
}

.document .name {
    overflow-x: auto;
}

.document-icon {
    font-size: 30px;
}
</style>
